import{jsx as r}from"react/jsx-runtime";import*as e from"feathers-react";const o=({children:o,...t})=>r(e.Table,{...t,children:o});o.Column=o=>r(e.Column,{...o});const t=o=>r(e.Container,{...o});export{t as Container,o as Table};
